import React, { useState, useContext } from 'react';
import moment from 'moment';

import { DataContext } from '../../../../stores/covering-table-store';
import { DataContext as MainDataContext } from '../../../../store';

import CorruptAssignmentsModal from './CorruptAssignmentsModal';

const CorruptAssignmentsAlert = ({ row }) => {
    // ------- DB Context -------
    const { store } = useContext(DataContext);
    const { selectedDate: selectedCoveringDate, latestDate: latestCoveringDate } = store;
    const selectedCoveringDateString = moment(selectedCoveringDate).format('YYYY-MM-DD').toString();
    const latestCoveringDateString = moment(latestCoveringDate).format('YYYY-MM-DD').toString();
    const {
        store: { user },
    } = useContext(MainDataContext);

    // ------- States
    const [isOpen, setIsOpen] = useState(false);

    // ------- Fields -------
    const isLatestCovDate = selectedCoveringDateString === latestCoveringDateString;
    const isEditable = isLatestCovDate && user.isAdmin;

    // ------- Component -------
    if (!row.assignments.some((a) => a.isCorrupt)) {
        return null;
    }
    return (
        <>
            <div className='alert alert-warning d-flex flex-row align-content-center mr-2' role='alert'>
                <div className='d-flex flex-column'>
                    <b>Konsulten har korrupta uppdrag.</b>
                    {isEditable && 'Funktionaliteten är instabil tills dessa åtgärdats.'}
                </div>
                <button className='btn btn-danger ml-2' onClick={() => setIsOpen(!isOpen)}>
                    {isEditable ? <h2 className='mb-1'>Hantera</h2> : <h2 className='mb-1'>Visa</h2>}
                </button>
            </div>
            <CorruptAssignmentsModal show={isOpen} onHide={() => setIsOpen(!isOpen)} row={row} />
        </>
    );
};

export default CorruptAssignmentsAlert;
